import { render, staticRenderFns } from "./BaseMediaButton.vue?vue&type=template&id=2c5e454e&scoped=true&"
import script from "./BaseMediaButton.vue?vue&type=script&lang=ts&"
export * from "./BaseMediaButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseMediaButton.vue?vue&type=style&index=0&id=2c5e454e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e454e",
  null
  
)

export default component.exports